// 机场攻略
export default [{
  name: 'queryApTrnInfo',
  method: 'post',
  desc: '查询机场基本信息',
  path: '/obt/queryApTrnInfo',
  params: {
    threeCode: '',
    terminal:''
  }
},{
  name: 'queryApAirlineInfo',
  method: 'post',
  desc: '查询机场航司柜台信息',
  path: '/obt/queryApAirlineInfo',
  params: {
    threeCode: '',
    terminal:''
  }
},{
  name: 'queryApTrfInfo',
  method: 'post',
  desc: '查询机场交通信息',
  path: '/obt/queryApTrfInfo',
  params: {
    threeCode: '',
    terminal: '',
    trfType:''
  }
},{
  name: 'queryApTrfDetail',
  method: 'post',
  desc: '交通线路详情',
  path: '/obt/queryApTrfDetail',
  params: {
    id:''
  }
},{
  name: 'getTicketStatus',
  method: 'post',
  desc: '校验票号',
  path: '/obt/getTicketStatus',
  params: {
    orderId:''
  }
},{
  name: 'cityAirportMsg',
  method: 'get',
  desc: '',
  path: '/obt/cityAirportMsg',
  params: {
	
  }
},{
  name: 'queryTianqi',
  method: 'post',
  desc: '',
  path: '"http://restapi.amap.com/v3/weather/weatherInfo',
  params: {

  }
}]